import React, { useState } from "react";

function UserSearch({ onSearch, onCreate }) {
    const [username, setUsername] = useState('');
    const [userStatus, setUserStatus] = useState(1);

    const handleSubmit = e => {
        e.preventDefault();
        onSearch(username, userStatus);
    };

    return (
        <div className="search-container">
            <form onSubmit={handleSubmit}>
                <label>
                    Username {' '}
                    <input type="text" value={username} onChange={e => setUsername(e.target.value)} />
                </label>
                <label htmlFor="userStatus">User Status: </label>
                <select id="userStatus" value={userStatus} onChange={e => setUserStatus(e.target.value)}>
                    <option value={0}>User Is Inactive</option>
                    <option value={1}>User Is Active</option>
                    <option value={2}>User Is Active or Inactive</option>
                </select>
                {' '}
                <button type="submit">Search</button>
                {' '}
                <button type="button" onClick={onCreate}>Create</button>
            </form>
        </div>
    );
}

export default UserSearch;
